import $i18n, { setConfig } from '@alife/panda-i18n';
import docCookie from 'cookie-curd';
import locale from 'src/locale';
$i18n.addLocale(locale);
const cookieKey = docCookie.getItem('i18n_lang') ? 'i18n_lang' : 'lang';
// 目前临时方案 因为每个地方的i18n并不共用，和遇久那边沟通过会出个统一方案
setConfig({
    cookieKey: cookieKey,
    logLevel: 0, // 关闭所有的国际化报错
});
console.log('【业务组件包wms-biz-components】 $i18n', $i18n);
// console.log('【业务组件包wms-biz-components】 cookie lang', cookieLang);
console.log('【业务组件包wms-biz-components】 $i18n lang', $i18n.getLang());
